import $, { each, isEmptyObject } from "jquery";
import debug from 'bows/dist/bows.min.js';


const log = debug("gtm-tracking");
const body = $('body');
const GTM_PUSHED_CLASS = 'gtm-pushed';


function stripHTML(html) {
  // Create a new div element
  let temporalDivEl = document.createElement("div");
  // Set HTML content using provider
  temporalDivEl.innerHTML = html;
  // Get the text property of the element (browser support)
  return temporalDivEl.textContent || temporalDivEl.innerText || "";
}

export function init() {
console.log('init please full v2.1');
  //Blog Analytics - OScript   
  var getBreadcrumb = function(listItems) {
    var data = [];
    listItems.each(function(idx, li) {
      var li = $(li);
      if(li.find('a').length){
        data.push(li.find('a').text());
      }
      else if(li.find('span.breadcrumb__dots').length) {
        data.push(li.find('span.breadcrumb__dots').text());
      }
    });
    
    return data;
  };
  
  // Coleman Liau Index calculation
      /* To speed the script up, you can set a sampling rate in words. For example, if you set
  * sampleLimit to 1000, only the first 1000 words will be parsed from the input text.
  * Set to 0 to never sample.
  */     
  var sampleLimit = 0;

  // Manual rewrite of the textstat Python library (https://github.com/shivam5992/textstat/)

  /* 
  * Regular expression to identify a sentence. No, it's not perfect. 
  * Fails e.g. with abbreviations and similar constructs mid-sentence.
  */
  var sentenceRegex = new RegExp('[.?!]\\s[^a-z]', 'g');

  /*
  * Regular expression to identify a syllable. No, it's not perfect either.
  * It's based on English, so other languages with different vowel / consonant distributions
  * and syllable definitions need a rewrite.
  * Inspired by https://bit.ly/2VK9dz1
  */
  var syllableRegex = new RegExp('[aiouy]+e*|e(?!d$|ly).|[td]ed|le$', 'g');

  // Baseline for FRE - English only
  var freBase = {
    base: 206.835,
    sentenceLength: 1.015,
    syllablesPerWord: 84.6,
    syllableThreshold: 3
  };

  var cache = {};

  var punctuation = ['!','"','#','$','%','&','\'','(',')','*','+',',','-','.','/',':',';','<','=','>','?','@','[',']','^','_','`','{','|','}','~'];

  var legacyRound = function(number, precision) {
    var k = Math.pow(10, (precision || 0));
    return Math.floor((number * k) + 0.5 * Math.sign(number)) / k;
  };

  var charCount = function(text) {
    if (cache.charCount) return cache.charCount;
    if (sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
    text = text.replace(/\s/g, '');
    return cache.charCount = text.length;
  };

  var removePunctuation = function(text) {
    return text.split('').filter(function(c) {
      return punctuation.indexOf(c) === -1;
    }).join('');
  };

  var letterCount = function(text) {
    if (sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
    text = text.replace(/\s/g, '');
    return removePunctuation(text).length;
  };

  var lexiconCount = function(text, useCache, ignoreSample) {
    if (useCache && cache.lexiconCount) return cache.lexiconCount;
    if (ignoreSample !== true && sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
    text = removePunctuation(text);
    var lexicon = text.split(' ').length;
    return useCache ? cache.lexiconCount = lexicon : lexicon;
  };

  var getWords = function(text, useCache) {
    if (useCache && cache.getWords) return cache.getWords;
    if (sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
    text = text.toLowerCase();
    text = removePunctuation(text);
    var words = text.split(' ');
    return useCache ? cache.getWords = words : words;
  }

  var syllableCount = function(text, useCache) {
    if (useCache && cache.syllableCount) return cache.syllableCount;
    var count = 0;
    var syllables = getWords(text, useCache).reduce(function(a, c) {  
      return a + (c.match(syllableRegex) || [1]).length;
    }, 0);
    return useCache ? cache.syllableCount = syllables : syllables;
  };

  var polySyllableCount = function(text, useCache) {
    var count = 0;
    getWords(text, useCache).forEach(function(word) {
      var syllables = syllableCount(word);
      if (syllables >= 3) {
        count += 1;
      }
    });
    return count;
  };

  var sentenceCount = function(text, useCache) {
    if (useCache && cache.sentenceCount) return cache.sentenceCount;
    if (sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
    var ignoreCount = 0;
    var sentences = text.split(sentenceRegex);
    sentences.forEach(function(s) {
      if (lexiconCount(s, true, false) <= 2) { ignoreCount += 1; }
    });
    var count = Math.max(1, sentences.length - ignoreCount);
    return useCache ? cache.sentenceCount = count : count;
  };

  var avgSentenceLength = function(text) {
    var avg = lexiconCount(text, true) / sentenceCount(text, true);
    return legacyRound(avg, 2);
  };

  var avgSyllablesPerWord = function(text) {
    var avg = syllableCount(text, true) / lexiconCount(text, true);
    return legacyRound(avg, 2);
  };

  var avgCharactersPerWord = function(text) {
    var avg = charCount(text) / lexiconCount(text, true);
    return legacyRound(avg, 2);
  };

  var avgLettersPerWord = function(text) {
    var avg = letterCount(text, false) / lexiconCount(text, false);
    return legacyRound(avg, 2);
  };

  var avgSentencesPerWord = function(text) {
    var avg = sentenceCount(text, false) / lexiconCount(text, false);
    return legacyRound(avg, 2);
  };

  var colemanLiauIndex = function(text) {
		//console.log('CLI - Text');
		//console.log(text);
	    var letters = legacyRound(avgLettersPerWord(text) * 100, 2);
		//console.log('CLI - Letters');
		//console.log(letters);
	    var sentences = legacyRound(avgSentencesPerWord(text) * 100, 2);
		//console.log('CLI - Sentences');
		//console.log(sentences);
    var coleman = 0.0588 * letters - 0.296 * sentences - 15.8;
    console.log('CLI - Coleman');
		console.log(coleman);
    //console.log('letters: ' + letters);
    //console.log('sentences: ' + sentences);
    //console.log('coleman: ' + coleman);
    return legacyRound(coleman, 2);
  };

  var readingTime = function(text) {
    var wordsPerSecond = 4.17;
    // To get full reading time, ignore cache and sample
    return legacyRound(lexiconCount(text, false, true) / wordsPerSecond, 2);
  };
  // [end] // Coleman Liau Index calculation
    
  var getBreakpoint = function () {
    // Media queries
    // xsmall: 0;
    // small: 640;
    // tablet: 768;
    // medium: 960;
    // large: 1024;
    // xlarge: 1200;
    // xxlarge: 1400;
    // xxxlarge: 1920;
    var breakpoints = [480, 640, 768, 960, 1024, 1200, 1400, 1920];
    var breakpoint = 320;
    $.each(breakpoints, function(index, value){
      if (window.matchMedia('(min-width: ' + value + 'px)').matches) {
      breakpoint = value;
      }
    });
    
    return breakpoint;
  };
  
  var getPageType = function (breadcrumb) {
    // Homepage, Site Search, Primary Nav Pages, Secondary Pages, Posts
    var pageType = 'none';
    
    // Compute cgPageType 
    if(breadcrumb.length == 2) {
      pageType = 'Primary Nav Pages';
    }
    else if(breadcrumb.length == 3) {
      pageType = 'Secondary Pages';
    }
    
    if (breadcrumb[1] === 'Blog') {
      pageType = 'Posts';
    }
    
    if (window.location.pathname == '/' ){
      pageType = 'Homepage';
    } else if (window.location.pathname == '/search-results/') {
      pageType = 'Site Search';
    }
    
    return pageType;
  };
  
  
//Page Tracking Scripts

      // var cdAuthor = $.trim($('#main article .container .post-meta .post-meta__author a').text());
      // var cdPublishedDate = $.trim($('#main article .container .post-meta .post-meta__date').text());
      // var cmBlogTagCount = $('#main article .container .post-meta .post-meta__terms a').length;
      var wpAdminBar = $('#wpadminbar');
      var cdTrafficType = 'external';
      if (wpAdminBar.length){
        cdTrafficType = 'internal';
      }
      var siteURL = window.location.origin;
      var cdSiteEnv = siteURL;
      var cdWorkEnv = 'local';
      if (cdSiteEnv.indexOf('technoserve.org') > -1) {
        cdWorkEnv = 'production';
      } else if (cdSiteEnv.indexOf('test-technoserve') > -1) {
        cdWorkEnv = 'test';
      } else if (cdSiteEnv.indexOf('dev-technoserve') > -1){
        cdWorkEnv = 'dev';
      }
      var cdAuthor = $.trim($('#main .post-meta__author a').text());
      var cdPublishedDate = $.trim($('#main .post-meta__date').text());
      var cmBlogTagCount = $('#main .post-meta__terms a').length;
    
      var breadcrumbData = getBreadcrumb($('ul.breadcrumb li'));
      var cgSiteSection = 'none';
      var cgBreadcrumb = 'none';

      var cdTheme = $('#main article').attr("cdTheme");
      var cdFormat = $('#main article').attr("cdFormat");
      var cdAngle = $('#main article').attr("cdAngle");
      
      if(cdTheme == undefined) { cdTheme = ''; }
      if(cdFormat == undefined) { cdFormat = ''; }
      if(cdAngle == undefined) { cdAngle = ''; }

      if (typeof breadcrumbData !== 'undefined') {
        cgSiteSection = breadcrumbData[1];
        cgBreadcrumb = '/' + breadcrumbData.join(' /');
      }
 
    
      var cgPageType = getPageType(breadcrumbData);
      if (cgPageType == 'Homepage'){
        cgSiteSection = 'homepage';
      }
      var content = '';
      if ($('#main article .container').length) {
        content = $('#main article .container').text();
      }
      else {
        content = $('#main').text();
      }
    
      var title = '';
      if ($('#main article .container .article-h1').length) {
        title = $('#main article .container .article-h1').text();
      }
      else {
        title = $('#main h1').text();
      }
    
      var excerpt = '';
      if ($('#main article .container p.h3').length) {
        excerpt = $('#main article .container p.h3').text();
      }
      else {
        excerpt = $('#main .container p.h3').text();
      }
      content = content.replace(/<img[^>"']*((("[^"]*")|('[^']*'))[^"'>]*)*>/g,"");
      content = content.replace(/\n{2,}\s*/g, '\n');
      var cmContentReadingLevel = colemanLiauIndex(content);
      var cmBlogTitleReadingLevel = colemanLiauIndex(title);
      var cmBlogExcerptReadingLevel = colemanLiauIndex(excerpt);

      var cdBreakpoint = getBreakpoint();
      var cdWordCount = getWords(content).length;

      if ($('body').hasClass('single-post')){
        /* UA Remove */
        window.dataLayer.push({ 
          'event': 'blogDataReady',
          'cdBreakpoint': cdBreakpoint,
          'cdWordCount': cdWordCount,
          'cdAuthor': cdAuthor,
          'cdPublishedDate': cdPublishedDate,
          'cdPublishedIn': cgSiteSection,
          'cgSiteSection': cgSiteSection,
          'cgPageType': cgPageType,
          'cgBreadcrumb': cgBreadcrumb,
          'cmContentReadingLevel': cmContentReadingLevel,
          'cmBlogTitleReadingLevel': cmBlogTitleReadingLevel,
          'cmBlogExcerptReadingLevel': cmBlogExcerptReadingLevel,
          'cmBlogTagCount': cmBlogTagCount,
          'oana': 'oana'
        });
        /* GA4 */
        window.dataLayer.push({ 
          'event': 'blog_data_ready',
          'angle': cdAngle,
          'author': cdAuthor,
          'breadcrumb': cgBreadcrumb,
          'breakpoint': cdBreakpoint,
          'format': cdFormat,
          'page_type': cgPageType,
          'published_date': cdPublishedDate,
          'published_in': cgSiteSection,
          'reading_level': cmContentReadingLevel,
          'site_env': cdSiteEnv,
          'site_section': cgSiteSection,
          'tag_count': cmBlogTagCount,
          'theme': cdTheme,
          'traffic_type': cdTrafficType,
          'word_count': cdWordCount,
          'work_env': cdWorkEnv,
        });
      }
      /* UA */
      window.dataLayer.push({ 
        'event': 'pageView',
        'cdBreakpoint': cdBreakpoint,
        'cdWordCount': cdWordCount,
        'cdAuthor': cdAuthor,
        'cdPublishedDate': cdPublishedDate,
        'cdPublishedIn': cgSiteSection,
        'cgSiteSection': cgSiteSection,
        'cgPageType': cgPageType,
        'cgBreadcrumb': cgBreadcrumb,
        'cmContentReadingLevel': cmContentReadingLevel,
        'cmBlogTitleReadingLevel': cmBlogTitleReadingLevel,
        'cmBlogExcerptReadingLevel': cmBlogExcerptReadingLevel,
        'cmBlogTagCount': cmBlogTagCount,
        'oana': 'oana',
        'cdTheme': cdTheme,
        'cdFormat': cdFormat,
        'cdAngle': cdAngle,
      });
      /* GA4 Update */
      

      window.dataLayer.push({ 
        'event': 'page_view',
        'angle': cdAngle,
        'author': cdAuthor,
        'breadcrumb': cgBreadcrumb,
        'breakpoint': cdBreakpoint,
        'format': cdFormat,
        'page_type': cgPageType,
        'published_date': cdPublishedDate,
        'published_in': cgSiteSection,
        'reading_level': cmContentReadingLevel,
        'site_env': cdSiteEnv,
        'site_section': cgSiteSection,
        'tag_count': cmBlogTagCount,
        'theme': cdTheme,
        'traffic_type': cdTrafficType,
        'word_count': cdWordCount,
        'work_env': cdWorkEnv,
      });
  

  //End Blog Analytics



  // EVENT TRACKING - Download Event
  $('a[href$=".pdf"]').click(function (event) {
    var text = $(this).text();

    if ($(this).closest('.archive-listing__content').find('.archive-listing__title').length) {
      text = $(this).closest('.archive-listing__content').find('.archive-listing__title').text();
    }
    /*
    var lSide = $(window).width() / 2;
    var downloadPosition = event.pageX < lSide ? 1 : 2;
    */
    var allDownloads = $('a[href$=".pdf"]');
    var downloadPosition = 1;
    for(let i = 0; i < allDownloads.length; i++){ 
      var tempText = $(allDownloads[i]).text();
      if ($(allDownloads[i]).closest('.archive-listing__content').find('.archive-listing__title').length) {
        tempText = $(allDownloads[i]).closest('.archive-listing__content').find('.archive-listing__title').text();
      }
      if (tempText == text){
        i = allDownloads.length;
      }
      downloadPosition++;
    }
    window.dataLayer.push({
      'event': 'download',
      'downloadName': text,
      'downloadPosition': downloadPosition,
    });
  });

  //Event tracking - Sidebar nav links
  $('#main a.jump-menu__link').click(function(){
    var anchorContent = $('main h1').text();
    anchorContent = stripHTML(anchorContent);
    var anchorType = 'Left Rail';
    var anchorName = $(this).text();
    anchorName = stripHTML(anchorName);
    window.dataLayer.push({
      'event': 'anchor',
      'anchorType': anchorType,
      'anchorContent': anchorContent,
      'anchorName': anchorName
    });
    window.dataLayer.push({
      'event': 'anchor_link',
      'content_interaction': 'left rail: ' + anchorName,
    });
  });


  // EVENT TRACKING - Click to Email
  $('a[href^="mailto:"]').click(function(){
    var email = $(this).attr('href').replace('mailto:', '');
    var text = $(this).text();

    var currentURL = $(location).attr('pathname');
    var closestHeader = $(this).closest("*:has('h1, h2, h3, h4, h5, h6')");
    
    closestHeader = $(closestHeader).find(":header").first();

    if ($(closestHeader).children().length == 0){
      closestHeader = $(closestHeader).text();
    } else {
   
      closestHeader = $(closestHeader).text();
    }

    if (currentURL.includes('contact-us')){
      text = $(this).parent().parent().find('.large strong').text();
      if (text == ''){
        text = $(this).parent().parent().find('.large b').text();
      }
    } else if ($(this).parent().parent().hasClass('staff-contact') == true){

      text = $(this).parent().parent().find('.staff__name').text();
      var staffTitle = $(this).parent().parent().find('.staff__name span').text();
      text = text.replace(staffTitle,'');
    } else if ($(this).hasClass('card__link')){ 
      text = $(this).find('.card__title').text();
    } else if (closestHeader !== ''){
      text = closestHeader;
    } else {
      text = $('#main h1').text();
    }
    window.dataLayer.push({
      'event': 'clickToEmail',
      'clickToEmailAddress': email,
      'clickToEmailName': text
    });
    window.dataLayer.push({
      'event': 'click_email',
      'content_interaction': text+': ' + email,
    });
  });

  // EVENT TRACKING - Click to Call
  $('a[href^="tel:"]').click(function(){
    var phone = $(this).attr('href').replace('tel:', '');
    var text = $(this).text();
    var currentURL = $(location).attr('pathname');
    var closestHeader = $(this).closest("*:has('h1, h2, h3, h4, h5, h6')");
    
    closestHeader = $(closestHeader).find(":header").first();

    
    if ($(closestHeader).children().length == 0){

      closestHeader = $(closestHeader).text();
    } else {
   
      closestHeader = $(closestHeader).text();
    }

    if (currentURL.includes('contact-us')){
      text = $(this).parent().parent().find('.large strong').text();
      if (text == ''){
        text = $(this).parent().parent().find('.large b').text();
      }
    } else if ($(this).hasClass('card__link')){ 
      text = $(this).find('.card__title').text();

    } else if ($(this).parent().parent().hasClass('staff-contact') == true){

      text = $(this).parent().parent().find('.staff__name').text();

      var staffTitle = $(this).parent().parent().find('.staff__name span').text();

      //console.log($(this).parent().parent());
      
      text = text.replace(staffTitle,'');
    } else if (closestHeader !== ''){
      text = closestHeader;
    }  else {
      text = $('#main h1').text();
    }
    window.dataLayer.push({
      'event': 'clickToCall',
      'clickToCallNumber': phone,
      'clickToCallName': text
    });

    window.dataLayer.push({
      'event': 'click_call',
      'content_interaction': text+': ' + phone,
    });
  });

  // EVENT TRACKING - Tabs click
  $('.sp-easy-accordion .ea-card .ea-header a.collapsed, ul[role="tablist"] li a').on('click', function () {
    var currentContext = $('main h1').text();
    var tabsName = $(this).text();

    window.dataLayer.push({
      'event': 'tabs',
      'tabsContent': currentContext,
      'tabsName': tabsName
    });
    window.dataLayer.push({
      'event': 'click_tab',
      'content_interaction': currentContext+ ': ' + tabsName,
    });
  });

  /*$('.js-wikit-tabbed ul[role="tablist"] a[role="tab"]').click(function() {
    var currentContext = $('main h1').text();
    var tabsName = $(this).text();

    window.dataLayer.push({
      'event': 'tabs',
      'tabsContent': currentContext,
      'tabsName': tabsName
    });
  });*/

  // EVENT TRACKING - pagination click
  $('body').on('click', '.pagination__num button, .pagination__nav button', function() {
    var paginationNumber = $(this).data('page');
    var paginationContent = $('main h1').text();

    window.dataLayer.push({
      'event': 'pagination',
      'paginationContent': paginationContent,
      'paginationNumber': paginationNumber
    });
    window.dataLayer.push({
      'event': 'click_pagination',
      'content_interaction': paginationContent + ': ' + paginationNumber,
    });
  });

  // EVENT TRACKING - search pagination click
  $('body').on('click', '.gsc-cursor .gsc-cursor-page', function(){
    var paginationNumber = $(this).text();
    var paginationContent = 'Site Search';

    window.dataLayer.push({
      'event': 'pagination',
      'paginationContent': paginationContent,
      'paginationNumber': paginationNumber
    });
  });

  // EVENT TRACKING - maps clicking
  /*$('#map, .leaflet-control-zoom-in, .leaflet-control-zoom-out').click(function(){
    window.dataLayer.push({
      'event': 'map',
      'mapAction': 'Explore',
      'mapLocation': ''
    });
  });

  $('#map, .leaflet-control-zoom-in, .leaflet-control-zoom-out').click(function(){
    window.dataLayer.push({
      'event': 'map',
      'mapAction': 'Explore',
      'mapLocation': ''
    });
  });*/

  $('.btn[data-modal="map-modal"]').on('click', function() {
      window.dataLayer.push({
        'event': 'map',
        'mapAction': 'Explore',
        'mapLocation': ''
      });
      window.dataLayer.push({
        'event': 'tool_map',
        'tool_step': 'step 1: map shown',
      });
  });

  $('body').on('click', '.map-popup .map-popup__text a', function(){
    var mapLocation = $(this).closest('.map-popup__text').find('.map-popup__title').text();

    window.dataLayer.push({
      'event': 'map',
      'mapAction': 'Contact',
      'mapLocation': mapLocation
    });
    window.dataLayer.push({
      'event': 'tool_map',
      'tool_step': 'step 3: contact: ' + mapLocation,
    });
  });

  // EVENT TRACKING - Related content clicks
  $('body').on('click', '.related__posts .related-post a', function(){
    var relatedPosition = $(this).closest('.related-post').index() + 1;
    var relatedName = $(this).closest('.related-post').find('a.related-post__link').text();

    window.dataLayer.push({
      'event': 'related',
      'relatedName': relatedName,
      'relatedPosition': relatedPosition
    });
    window.dataLayer.push({
      'event': 'click_related_content',
      'content_interaction': relatedName+ ': ' + relatedPosition,
    });
  });

  // EVENT TRACKING - Filters clicks
  $('body').on('click', '.facetwp-type-fselect .fs-option:not(.selected)', function(){
    var filtersContent = $('#main h1').text();
    var filter = $(this).closest('.facetwp-type-fselect').find('select.facetwp-dropdown option:first-of-type').text();
    var selection = $(this).find('.fs-option-label');
    selection.find('span').remove();

    var filtersName = filter + ' - ' + $.trim(selection.text());

    window.dataLayer.push({
      'event': 'filters',
      'filtersContent': filtersContent,
      'filtersName': filtersName
    });
    window.dataLayer.push({
      'event': 'drop_down',
      'content_interaction': filtersContent + ': ' + filtersName,
    });
  });

  // EVENT TRACKING - Donation success.
	if (body.hasClass('page-id-11084')) {
		// This is a hubspot form submission success page. Redirects to this page. User can use Paypal
		// as well so execute push simply on page load.
		/*dataLayer.push({
			'event': 'formSuccess',
			'formName': 'Donate Now',
			'formSuccessId': '025984357'
		});*/
	}

  // EVENT TRACKING - Donate Now page load
  window.addEventListener("message", function(event) {
    //Good for debugging HS events
    //console.log('found message ' + event.data.type);
    //console.log(event);
    if (event.data.accepted == true){
      window.conversionID = event.data.conversionId;
    }
    if(event.data.type == 'hsFormCallback'){
    
      const HS_SIGNUP_ID = 'f027ea34-f0d6-45f9-b623-c22b0120e13f';
    
      const HS_SIGNUP_ID2 = '94ac8955-9128-4670-9782-56796955b887';
      
      //const HS_DONATION_ID = 'a203c6e4-1ce4-4d27-a34f-7810ea87eee5';
      const HS_DONATION_ID = '360debf6-7ee8-45b0-816b-544ae0d9384e';
      
      const HS_FORM_ID = event.data.id;

      var hs_event_id = event.data.id;
      var hs_event_name = event.data.eventName;
      var hs_event_type = event.data.type;

      // Function to log event for form field name.
      var pushFormFieldEnter = function($form, $elements, formName,formGoal) {
        //console.log('form input init');
        $elements.one('focus', function(){
          var newField = $(this).attr('name');
          var fieldID = $(this).attr('ID');
          if (!$form.hasClass(GTM_PUSHED_CLASS + '-start')) {
            $form.addClass(GTM_PUSHED_CLASS + '-start');

            //Tracks form start
            /* UA Remove */
            window.dataLayer.push({
              'event': 'formStart',
              'formName': window.formName[HS_FORM_ID],
              'formGoal': formGoal,
              'elementID': HS_FORM_ID
            });
            /* GA4 */
            window.dataLayer.push({
              'event': 'form_start',
              'form_name': window.formName[HS_FORM_ID],
              'form_goal': formGoal,
              'element_id': fieldID
            });

            //Tracks donate/e-commerce form start
            if (formName !== 'Sign Up Form' && formName !=='Sign Up' && formName !== 'sign up form' && formName !=='sign up' && formName !== 'Pop Up' && formName !== 'Form' && formName !== 'pop up' && formName !== 'form'){
              window.dataLayer.push({
                'event': 'checkout2',
                'ecommerce': {
                  'checkout': {
                    'actionField': {'step': 2, 'option': 'Form Start'},
                    'affiliation': window.formName[HS_FORM_ID],
                    'products': [{
                      'name': formName,
                      'id': hs_event_id
                    }]
                  }
                },
                'eventCallback': function() {
      //              document.location = '/support-us/thank-you/';
                }
              });

              var formVal = $('#amount').val();
              if ($(this).val() && $(this).val().indexOf('$') > -1){
                formVal = $(this).val();
              } 
              window.dataLayer.push({
                'event': 'add_to_cart',
                'currency': 'USD',
                'value': formVal,
                'ecommerce': {
                  'items': {
                  'products': [{
                    'item_name': window.formName[HS_FORM_ID],
                    'item_id': HS_FORM_ID,
                    'price': formVal,
                    'quantity': 1
                  }]
                  }
                }
                });

            }
          } 

         

          /* This check surpesses duplicate focus field triggers that
          can occur due to tabbing out and back into your browser */
      
           
          if(window.lastFocus !== fieldID){
            window.lastFocus = fieldID;
            /* UA Remove */
            window.dataLayer.push({
              'event': 'formFieldEnter',
              'formName': window.formName[HS_FORM_ID],
              'formField': newField,
              'formGoal': formGoal,
              'elementID': HS_FORM_ID
            });
            /* GA4 */
            window.dataLayer.push({
              'event': 'form_field',
              'form_name': window.formName[HS_FORM_ID],
              'form_field': newField,
              'form_goal': formGoal,
              'element_id': fieldID
            });
          }
        });
      }

      // Signup Form GTM event.
      var signUpFormGTM = function() {
        switch (hs_event_name) {
          case 'onFormSubmitted':
            var $container = $('#hs' + HS_FORM_ID);
            /*
            if (!$container.length) {
              $container = $('#hs' + HS_SIGNUP_ID2);
            }
            */
            if ($container.length) {
              var $submit_message = $('.submitted-message', $container);

              if ($submit_message.length && !$submit_message.hasClass(GTM_PUSHED_CLASS)) {
                var message = $submit_message.text();

                if (message === 'Thanks for signing up.') {
                  /* UA Remove */
                  window.dataLayer.push({
                    'event': 'formSuccess',
                    'formName': window.formName[HS_FORM_ID],
                    'formSuccessId': window.conversionID,
                    'formGoal': 'email',
                    'elementID': HS_FORM_ID
                  });
                  
                  /* GA4 */
                  window.dataLayer.push({
                    'event': 'form_complete',
                    'form_name': window.formName[HS_FORM_ID],
                    'form_success_id': window.conversionID,
                    'form_goal': 'email',
                    'form_selection': 'na',
                    'status': 'success'
                  });
                  window.dataLayer.push({
                    'event': 'sign_up',
                    'method': 'email newsletter',
                    'status': 'success'
                  });
                  window.dataLayer.push({
                    'event': 'join_group',
                    'group_id': 'signed up'
                  });
                  window.conversionID = '';
                }

                $submit_message.addClass(GTM_PUSHED_CLASS);
              }
            }
            break;
          default:
            var $form = $('#hsForm_' + HS_FORM_ID)

            if (!$form.length) {
              console.log('Cannot find form ' + HS_FORM_ID);
            }
            window.formName[HS_FORM_ID] = 'sign up - ' + HS_FORM_ID;
              pushFormFieldEnter($form, $('input', $form), 'sign up','email');
     
            break;
        }
        
      }
      // Default Form GTM event.
      var defaultFormGTM = function(fName) {
        var $form = $('.hs-form-' + HS_FORM_ID);
        if ($form.length) {
          if (hs_event_name == 'onFormReady'){
            pushFormFieldEnter($form, $('input', $form), fName,'email');
          
          } else if (hs_event_name == 'onFormSubmitted'){
            window.dataLayer.push({
              'event': 'formSuccess',
              'formName': window.formName[HS_FORM_ID],
              'formSuccessId': window.conversionID,
              'elementID': HS_FORM_ID
            });
            window.conversionID = '';
          }
        }
      };
      // Donation Form GTM event.
      var donationFormGTM = function() {
        var $form = $('.hs-form-' + HS_FORM_ID);

        if ($form.length) {

          

          var $amount = $('input.amount', $form);
          
          if (hs_event_name == 'onFormReady'){

            
              // Apply click event to donation amounts.
              $('input[name="donation_amounts"]').on('click', function(){
                $amount.trigger('change');
              });

              pushFormFieldEnter($form, $('input', $form), 'donate now', 'donate');

              //Does not fire
          } else if (hs_event_name == 'xonFormSubmitted'){
           // console.log('Event Details;')
            //console.log(event.data);
            

            window.dataLayer.push({
              'event': 'formSuccess',
              'formName': 'Donate Now',
              'formSuccessId': window.conversionID
            });
            window.conversionID = '';

            window.dataLayer.push({
              'event': 'purchase',
              'cdDonationSuccessId': '5687251',
                'ecommerce': {
                  'purchase': {
                    'actionField': {
                      'id': 'T12345',                         // cdDonationSuccessId
                      'revenue': '200.00'                     // Total transaction value (incl. tax and shipping)
                    },
                    'products': [{                            // List of productFieldObjects.
                        'name': 'Donate Now',                   // name is the Form Name
                        'id': HS_FORM_ID,                        // id is the Form Id.
                        'price': '200.00',                    // price is the donation amount selected.
                        'brand': 'One Time',           // one time or new monthly donation.
                        'category': 'PayPal',           // PayPal or Credit Card
                        'variant': 'In memory of, Make donation anonymous, Help cover processing fees, Receive other communications',                
                        'quantity': 1
                    }]
                  }
                }
            });

          }
          
        }
      }

      if(hs_event_type === 'hsFormCallback' && hs_event_name === 'onFormSubmitted') {
        //If this is the signup form, trigger the 
        if (hs_event_id == HS_SIGNUP_ID || hs_event_id == HS_SIGNUP_ID2){
          console.log('confirm signup form submitted');
          signUpFormGTM();

        } else if ($('#donation-embed .hs-form-'+hs_event_id).length > 0){
  
          donationFormGTM();
        } else {
          if ($('.sgpb-main-html-content-wrapper .hs-form-'+hs_event_id).length > 0){
            name = 'pop up';
          } else {
            name = 'form';
          }
          defaultFormGTM(name);
        }
      }

      if(hs_event_type === 'hsFormCallback' && hs_event_name === 'onFormReady') {
        var name = '';
        //console.log('ID ' + hs_event_id);
              /*case '360debf6-7ee8-45b0-816b-544ae0d9384e':
            name = 'Donate Now';
            break;
            */
        window.formName = window.formName || {};
        console.log('found form ' + hs_event_id);
        if (hs_event_id == HS_SIGNUP_ID || hs_event_id == HS_SIGNUP_ID2){
          name = 'sign up';
          if (!window.formName[HS_FORM_ID]){
            window.formName[HS_FORM_ID] = 'newsletter signup form -  ' + hs_event_id;
          }
          console.log('confirm signup form init');
          signUpFormGTM();

        } else if ($('#donation-embed .hs-form-'+hs_event_id).length > 0){
          name = 'donate now';
          if (!window.formName[HS_FORM_ID]){
            window.formName[HS_FORM_ID] = 'donation form - ' + hs_event_id;
          }
          donationFormGTM();
        } else {
          setTimeout(function(){

          },3500);
          // console.log('Form ID ' + hs_event_id );
          if ($('.sgpb-popup-builder-content-html .hs-form-'+hs_event_id).length > 0){
            name = 'pop up';
            if (!window.formName[HS_FORM_ID]){
              window.formName[HS_FORM_ID] = 'pop up - ' + hs_event_id;
            }
          } else {
            name = 'form';
            if (!window.formName[HS_FORM_ID]){
              window.formName[HS_FORM_ID] = 'form - ' + hs_event_id;
            }
          }
          defaultFormGTM(name);
        }

        if (name == 'donate now') {
          window.dataLayer.push({
            'event': 'checkout1',
            'ecommerce': {
              'checkout': {
                'actionField': {'step': 1, 'option': 'Page Load'},
                'affiliation': window.formName[HS_FORM_ID],
                'products': [{
                  'name': name,
                  'id': hs_event_id
                }]
              }
            },
            'eventCallback': function() {
  //              document.location = '/support-us/thank-you/';
            }
          });
          var formVal = $('#amount').val();
          window.dataLayer.push({
            'event': 'view_item',
            'currency': 'USD',
            'value': formVal,
            'ecommerce': {
              'items': {
              'products': [{
                'item_name': window.formName[HS_FORM_ID],
                'item_id': HS_FORM_ID,
                'price': formVal,
                'quantity': 1
              }]
              }
            }
            });

        }
      }
    }
  });

  // EVENT TRACKING - Donate Now form start
  // User inputs a specific amount.
  /*
  $('body').on('focus', '#amount', function(event) {
    
    if($('#amount').val() == 0) {
      console.log(event);
      window.dataLayer.push({
        'event': 'checkout2',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': 2, 'option': 'Form Start'},
            'products': [{
              'name': 'Donate Now',
              'id': '360debf6-7ee8-45b0-816b-544ae0d9384e'
            }]
          }
        },
        'eventCallback': function() {
//                document.location = '/support-us/thank-you/';
        }
      });
    }
  });
  */
  // User is selecting a default amount.
  $('body').on('focus', 'input[name="donation_amounts"]', function(event) {
    /*
    if($('#amount').val() == 0) {
      console.log('value trigger?');
      console.log(event);
      window.dataLayer.push({
        'event': 'checkout2',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': 2, 'option': 'Form Start'},
            'products': [{
              'name': 'Donation Form - WP',
              'id': '360debf6-7ee8-45b0-816b-544ae0d9384e'
            }]
          }
        },
        'eventCallback': function() {
//                document.location = '/support-us/thank-you/';
        }
      });
    }*/
  });

  // EVENT TRACKING: Search Start
  //Google Search Results Page
  $('.main').on('focus', 'input[name^="search"]', function(event) {
    var newField = $(this).attr('name');
    if($(this).val().length == 0) {
      if(window.lastFocus !== newField){
        window.lastFocus = newField;
        window.dataLayer.push({
          'event': 'searchStart',
          'searchType': 'Site Search'
        });
      }
    }

  });
  //Click top search icon
  $('body').on('click', '.main-nav__search', function(event) {
    var newField = $(this).attr('name');
    if ($(this).attr( "tabindex" ) == -1) {
      if(window.lastFocus !== newField){
        window.lastFocus = newField;
          window.dataLayer.push({
            'event': 'searchStart',
            'searchType': 'Site Search'
          });
        }

    }

  });
  //Share on Social
  $('.addtoany_share_save_container').on('click', 'a', function(event) {
    var shareTarget = $(this).attr('title');
    var pageTitle = $(document).find("title").text();
    var contentType = 'page';
    if ($('body').hasClass('single-post')){
      contentType = 'blog post';
    } 
      window.dataLayer.push({
        'event': 'share',
        'content_type': contentType,
        'item_id': pageTitle,
        'method': shareTarget
      });
  });
  

  

  //Facet Search On Blog
  $('body').on('focus', 'input[class^="facetwp-search"]', function(event) {
    var newField = $(this).attr('name');
    if($(this).val().length == 0) {
      if(window.lastFocus !== newField){
          window.lastFocus = newField;
        var $searchType = '';
        var $placeholder = $(this).attr('placeholder')
        if ($placeholder == 'Search Blogs'){
          $searchType = 'Blog Search';
        } else if ($placeholder == 'Search Resources'){
          $searchType = 'Resources Search';
        } else if ($placeholder == 'Search News'){
          $searchType = 'News Search';
        }
        window.dataLayer.push({
          'event': 'searchStart',
          'searchType': $searchType
        });
        console.log('search start 2');
      }
    }
  });


  // EVENT TRACKING: Search Search
  var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  // Utility function get data facet search data for reuse.
  var getFacetSearch = function () {
		// Search for pages at Resources, Blog, and News sections.
		var facetSearchTerm = "";
		var facetSearchType = "";
		var href = window.location.href;
		var validFacetSearch = ["blog/?fwp_search_blogs=", "resources/?fwp_search_resources=", "news/?fwp_search_news="];
		var resultCount = window.FWP_JSON.preload_data.settings.pager.total_rows; // Get the count from the JSON object in the DOM.
		var isValidSearch = validFacetSearch.some(function(searchName) {
			var found = (href.indexOf(searchName) !== -1);
			var facetName = searchName.split("/").slice(0,1).shift();

			facetSearchType = facetName.charAt(0).toUpperCase() + facetName.slice(1) + ' Search';
			facetSearchTerm = getUrlParameter(searchName.split("/").slice(1).shift().replace("?", "").replace("=", ""));

			return found;
		});

		return {
			isValidType: isValidSearch,
			term: facetSearchTerm,
			type: facetSearchType,
			count: resultCount,
		}
	};

	$(document).ready(function() {
		var searchTerm = getUrlParameter('search');

		var searchSearch = function(searchType, searchTerm, resultCount) {
			window.dataLayer.push({
				'event': 'searchSearch',
				'searchType': searchType,
				'searchTerm': searchTerm,
				'searchResults': resultCount
			});
		}

		if (window.location.href.indexOf('search-results/?search=') > -1 && searchTerm !== '') {
			setTimeout(function() {
				var resultInfoNo = $('.gsc-result-info').text().replace(',', '').replace('.', '').match(/\d+/);
				var resultCount = resultInfoNo[0];

				searchSearch("Site Search", searchTerm, resultCount);
			}, 2000);
		}



    $(document).on('facetwp-loaded', function() {
      var facetData = getFacetSearch();
      if (facetData.isValidType && facetData.term !== '') {
        searchSearch(facetData.type, facetData.term, facetData.count);

        var $facetResultContainer = $(".facetwp-template");

        if ($facetResultContainer.length) {
          $facetResultContainer.find(".archive-listing__link").on('click', function(e) {
             var contentTitle = $(this).find('.archive-listing__title').text();
              searchClick(facetData.type, facetData.term, facetData.count, contentTitle);
 
          });
        }

      }
      
    });
	});
	// END EVENT TRACKING: Search Search


	// EVENT TRACKING: Search click
	var searchClick = function(searchType, searchTerm, resultCount, contentTitle) {
    /* UA Remove */
		window.dataLayer.push({
			'event': 'searchClick',
			'searchType': searchType,
			'searchTerm': searchTerm,
			'searchResults': resultCount,
      'anchorContent': contentTitle
		});
    /* GA4 */
    window.dataLayer.push({
			'event': 'select_content',
			'content_type': searchType,
			'search_term': searchTerm,
      'item_id': contentTitle
		});
	};

	$(document).ready(function() {
		
	});

  $('body').on('click', '.gsc-result a', function() {
    var searchTerm = getUrlParameter('search');
    var searchTerm = $('input.gsc-input').val();
    var resultInfoNo = $('.gsc-result-info').text().replace(',', '').match(/\d+/);
    var contentTitle = $(this).text();
    var resultCount = resultInfoNo[0];

    searchClick('Site Search', searchTerm, resultCount,contentTitle);
  });
  // END EVENT TRACKING: Search click

  // EVENT TRACKING: Featured content event click
  $('body').on('click', '.listing__link', function() {
    var section_title = $(this).closest('.listings').find('.listings__heading').text();
    //&& section_title.toLowerCase().indexOf("featured") >= 0
    if (section_title.length > 0 ) {
      var content_title = $(this).find('.listing__title').text();
      var positionCount = $(this).parent().index();
      window.dataLayer.push({
        'event': 'featured',
        'featuredType': 'Vertical',
        'featuredName': section_title + ' - ' + content_title,
        'featuredPosition': positionCount
      });
      window.dataLayer.push({
        'event': 'click_featured_content',
        'content_interaction': 'Vertical: ' + section_title + ' - ' + content_title,
      });
    }
  });
  // EVENT TRACKING: Featured content event click

  // EVENT TRACKING: load more
  var resorces_more_clicked = 0;
  $('button#resources-listing-more').on('click', function() {
    var section_title = $(this).closest('section.resources-listing').find('h2.resources-listing__title').text();

    if(section_title != '') {
      resorces_more_clicked++;

      window.dataLayer.push({
        'event': 'loadMore',
        'loadMoreName': section_title,
        'loadMorePosition': resorces_more_clicked
      });
      window.dataLayer.push({
        'event': 'load_more',
        'content_interaction': 'load more: ' + section_title,
      });
    }
  });
  // END EVENT TRACKING: load more

  //EVENT TRACKING: Quiz

  if ($('body').hasClass('single-post') && $('#main .gform_body').length){
//Has a quiz!
    var quiz_elem = $('#main .gform_body');
    $('#main .gform_body input').on('click',function(){
      if (!$(quiz_elem).hasClass('started-quiz')) {
        $(quiz_elem).addClass('started-quiz');
        window.dataLayer.push({
          'event': 'tool_quiz',
          'tool_step': 'step 1: quiz started',
        });
      }
      var fieldID = $(this).attr('id');
      var fieldLabel = $(quiz_elem).find("label[for='"+fieldID+"']").text();
      window.dataLayer.push({
        'event': 'tool_quiz',
        'tool_step': 'step 2: answered: ' + fieldLabel,
      });
    });
  }

  // EVENT TRACKING: popup content click
  $(window).on('sgpbPopupContentclick', function(e, settings) {
    var popup_content = $('.sg-popup-builder-content:visible');

    if(popup_content.html() != '') {
      var popup_title = '';
      var popup_title_tags = ['h1', 'h2', 'h3','h4','h5'];

      for(var i in popup_title_tags) {
        var popup_title_tag = popup_content.find(popup_title_tags[i]);

        if(popup_title_tag.length > 0) {
          popup_title = popup_title_tag.text();
          break;
        }
      }
      if (popup_title == ''){
        popup_title = $(popup_content).firstChild().attr('class');
      }
      if(popup_title != '') {
        window.dataLayer.push({
          'event': 'popUp',
          'popUpAction': 'Click',
          'popUpName': popup_title
        });
      }
    }
  });
  // END EVENT TRACKING: load more

  // EVENT TRACKING: popup impression
  $(window).on('sgpbPopupReload', function(e) {
    //console.log('Detected popup');
		var popup_content = $('.sg-popup-builder-content:visible');
		var popupHTML = popup_content.html();
		var has_popupContent = (popupHTML !== '');

		// Event tracker for the Popup Builder plugin.
		var popUpBuilderFormStartGTM = function () {
			var $popupContainer = $('.sgpb-fadeIn:visible');

			if (!$popupContainer.length) {
				return null;
			}
      /*
			var $form = $('form', $popupContainer);

			if ($form.length) {
				$('input').on('focus', function() {

						$form.addClass(GTM_PUSHED_CLASS);
					if (!$form.hasClass(GTM_PUSHED_CLASS)) {
						window.dataLayer.push({
							'event': 'formStart',
							'formName': 'Pop Up'
						})

					}
				});
			}*/
		}
    


		if (popup_content.length && has_popupContent) {
			setTimeout(function(){
				//popUpBuilderFormStartGTM();
			}, 1000);
		}


		if (popup_content.length && has_popupContent) {
			setTimeout(function(){
				//popUpBuilderFormStartGTM();
			}, 1000);
		}

    if(!popup_content.hasClass('gtm-pushed') && has_popupContent) {

      var popup_title = '';
      var popup_title_tags = ['h1', 'h2', 'h3','h4','h5'];

      for(var i in popup_title_tags) {
        var popup_title_tag = popup_content.find(popup_title_tags[i]);

        if(popup_title_tag.length > 0) {
          popup_title = popup_title_tag.text();
          break;
        }
      }
      if (popup_title == ''){
        popup_title = $(popup_content).firstChild().attr('class');
      }
      if(popup_title != '') {
        window.dataLayer.push({
          'event': 'popUp',
          'popUpAction': 'Impression',
          'popUpName': popup_title
        });

        popup_content.addClass('gtm-pushed');
      }
    }
  });
  // END EVENT TRACKING: popup impression

	// Use window on load for Hubspot forms. It will wait for all items to load on a page
	// before executing vs JQuery waiting for DOM. It will loop through a setinterval until Hubspot form is loaded.
	// https://community.hubspot.com/t5/CMS-Development/Input-forms-JS-improperly-compile-or-conflict-on-page-load/m-p/316176/highlight/true#M15140
	$(window).on('load', function () {

    function startPopupTracker(){
      var popupContent = $('div[class~="eapp-popup-layout-variation-slide-in-right-component-enter-done"]');
      var popupTitle = $('div[class^="TextBlock__TextHTML"]').first().text();
      var popupButton = $('div[class~="eapp-popup-layout-variation-slide-in-right-component-enter-done"] button')[1];
      console.log('popup ' + popupTitle + ' ' + popupContent + ' but ' + popupButton);
      if ($(popupContent).length){
        window.dataLayer.push({
          'event': 'pop_up',
          'content_interaction': popupTitle + ' pop up shown',
        });
        $($('div[class~="eapp-popup-layout-variation-slide-in-right-component-enter-done"] button')[1]).on('click',function(){
          window.dataLayer.push({
            'event': 'pop_up',
            'content_interaction': popupTitle + ' click button',
          });       
        });
      } else {
        console.log('No popup found');
      }
    }
    $(window).scroll(function(){
      if (window.popinit !== true){
        window.popinit = true;
   
        setTimeout(function(){
          console.log('popup check');
          if ($('div[class~="eapp-popup-layout-variation-slide-in-right-component"]').length) {
            startPopupTracker();
            
          }
        }, 5000);
      }
    });



    window.qmn_quiz_data
		// Quiz form GTM events.
		if ($('.interact_responsive_wrapper').length) {
			//var quizForm = setInterval(quizInterval, 1500);
		}

		function quizInterval () {
			var $iframe = $(iframe).contents();
			var $container = $iframe.find('[class*="main__container____"]');

			if ($container.length){
				clearInterval(quizForm);

				$('[class*=main__answer-reveal-next___]').on('click', function(){
					var $iframe_contents = $("iframe").contents();

					var $counter = $iframe_contents.find('[class*=main__counter____]');
					var $title = $iframe_contents.find('[class*=main__question-title___]');
					var $incorrect = $iframe_contents.find('[class*=main__answer-reveal-incorrect___]');
					var is_correct = (!$incorrect.length);

					//console.log($counter);
					//console.log($incorrect.length);
				});

			}

			/**
			window.dataLayer.push({
				'event': 'quiz',
				'quizNumber': '1',
				'quizQuestion': 'Women account for what percentage of agricultural landholders around the world?',
				'quizAnswerCorrect': 'Correct',
				'quizAnswer': '12.8%'
			});
			*/
		}
	});

  var quizForm = $('form.qsm-quiz-form');

  if(quizForm.length > 0) {
    var existCondition = setInterval(function() {
      var next_btn = $('a.mlw_next');

      if (next_btn.length > 0) {
        clearInterval(existCondition);
        //console.log('next hook');
        next_btn.on('click', checkAnswer);
      }
     }, 100);
     var existCondition2 = setInterval(function() {
      var submit_btn = $('.qsm-submit-btn');

      if (submit_btn.length > 0) {
        clearInterval(existCondition2);
       
        //console.log('submit hook');
      
        submit_btn.on('click', function(){
          if (window.lastQuestion === undefined){
            window.lastQuestion = true;
            checkAnswer();
            return false;
          }

        });
      }
     }, 200);
  }
}
function checkAnswer(){
  var answers_cnt =  $('.qmn_radio_answers');
  //console.log('clicky');
  //console.log(window.qmn_quiz_data[Object.keys(window.qmn_quiz_data)[0]]);
  window.$quiz_id = window.qmn_quiz_data[Object.keys(window.qmn_quiz_data)[0]].quiz_id;
  window.$quiz_name = window.qmn_quiz_data[Object.keys(window.qmn_quiz_data)[0]].quiz_name;
  if(window.$question_list === undefined){
    window.$question_list = window.qmn_quiz_data[Object.keys(window.qmn_quiz_data)[0]].question_list;
  }

  if(answers_cnt.length > 0) {
    var $active_question = $(".quiz_section:visible");
    //console.log($active_question);
    var slide_number = $('input[name="slide_number"]');
    var target_slide = slide_number.val()-1;
    //If we're on the last question, grab the last slide value
    if (window.lastQuestion == true){
      target_slide = slide_number.val();
    }
    //console.log('slide ' + slide_number.val());
   var $checked_radio = $('.slide'+target_slide + ' input.qmn_quiz_radio:checked');
   
   if ($checked_radio.length > 0){
    //console.log($checked_radio);
    //console.log($($checked_radio).attr('id'));

    var $radio_id = $($checked_radio).attr('id');
    var $question_id = $radio_id.replace('question','');
    var $id_split = $question_id.split('_');
    $question_id = $id_split[0];
    var $answer_index = $id_split[1] - 1;
    //console.log('Question = ' + $question_id);
    //console.log(window.$question_list[$question_id]);



    //var $quiz_question = window.$question_list[$question_id].question_answer_info;
    var $quiz_question = $('.question-section-id-' + $question_id + ' .mlw_qmn_question').text();
    $quiz_question = stripHTML($quiz_question);
    var $answer_correct = 'Incorrect';
    var $quiz_answer = $($checked_radio).val();

    var $question_answers = window.$question_list[$question_id].answers;
    var $selected_answer = $question_answers[$answer_index];
    if ($selected_answer[0] == $quiz_answer) {
      if($selected_answer[2] == 1){
        $answer_correct = 'Correct';
      }
    } else {
      //console.log('Answer mismatch');
    }

    
    window.dataLayer.push({
      'event': 'quiz',
      'quizNumber': window.$quiz_id,
      'quizTitle': window.$quiz_name,
      'quizQuestion': $quiz_question,
      'quizAnswerCorrect': $answer_correct,
      'quizAnswer': $quiz_answer
      });
      if (window.lastQuestion == true){
        $('.qsm-submit-btn').click();
      }

   }
    /*var visible_quiz_section = ('.quiz_section:visible');
    console.log(visible_quiz_section);
    var checked_radio = $('.quiz_section:visible input.qmn_quiz_radio:checked');
    console.log(checked_radio.val());*/
  }
}

export default {
  init
};
function CookiebotCallback_OnAccept() {
  init();
  console.log('cookie fire');
  }
  console.log('full track');

  if ($('.page-template-donate-optimized').length || $('.page-template-home-optimized').length || $('.page-template-about-us-optimized').length){
    init();
  }
